import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import React from "react";

const UpgradeModal = ({openNonEditableModal , setOpenNonEditableModal}) => {
  return (
    <div>
      <Dialog
        open={openNonEditableModal}
        onClose={() => setOpenNonEditableModal(false)}
        as="div"
        className="absolute inset-0 mx-auto  flex flex-col text-white"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 mx-auto bg-black opacity-80" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="relative z-10 mx-auto my-auto flex w-[90%] flex-col items-center justify-center rounded-xl bg-white p-4 text-center md:w-[30%] md:p-6 ">
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src="https://assets.learntube.ai/files/Ai%20notes/Business%20Support%20For%20Success.gif?updatedAt=1713947271511"
            className=" w-[50%]"
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
          />
          <div className="mt-1 text-center text-black text-[16px] font-semibold md:text-[20px]">
            This Is A LearnTubeX Feature
          </div>
          <div className="mt-1 text-[12px] text-black md:text-[14px]">
            Upgrade to LearnTubeX to view and edit Learner Notes and achieve
            your goals 2x faster
          </div>
          <button
            className="mt-2 flex cursor-pointer items-center justify-center px-8 py-2 text-[14px] font-semibold text-white md:mt-4 md:text-[18px]"
            style={{
              borderRadius: "12px",
              background: "#1CA571",
              boxShadow: "1.3951px 1.3951px 5.58042px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={(e) => window.open("/pricing", "_blank")}
          >
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src="https://assets.learntube.ai/files/Content_player/Group%209045.svg?updatedAt=1693995597919"
              className="mr-1 h-[20px] w-[20px]"
              transformation={[
                {
                  height: "160",
                  width: "160",
                },
              ]}
            />
            Upgrade To LearnTubeX
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default UpgradeModal;
